import React, { ErrorInfo, ReactNode } from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { ErrorPage } from '@groma-dev/blueprint';

interface ErrorBoundaryState {
  hasError: boolean;
}

interface ErrorBoundaryProps extends WrappedComponentProps {
  children: ReactNode;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);

    this.state = { hasError: false };
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this._logErrorToMyService(error, errorInfo);
  }

  _logErrorToMyService(error: Error, errorInfo: ErrorInfo) {
    console.error(error);
    console.error('Error Info', errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorPage
          errorMessage={this.props.intl.formatMessage({
            id: 'errorBoundary.errorMessage',
            defaultMessage: 'Application Error',
            description: 'Error Boundary application error message',
          })}
          content={this.props.intl.formatMessage({
            id: 'errorBoundary.errorContent',
            defaultMessage:
              "Well, this is embarrassing...we're looking into the issue. Sorry for any inconvenience this may cause.",
            description: 'Error Boundary error content message',
          })}
          link={<></>}
        />
      );
    }

    return this.props.children;
  }
}

export default injectIntl(ErrorBoundary);
